export default __webpack_public_path__ + "locales/statements.kk.json";